/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import BobModal from '../../../components/BobModal';
import * as classes from './ConditionalFormatModal.module.css';
import TextField from '@material-ui/core/TextField';
import DateField from '../../../components/FormFields/DateField';
import ConditionalFormatDropdown from '../../../components/ConditionalFormatDropdown';

const ConditionalFormatModal = ({
    onClose,
    close,
    open,
    title,
    formatList,
    formatKey,
    formatType,
    setFormatList,
    formatObj,
    setFormatObj,
    updateUserView,
    ...props
}) => {
    const [showError, setShowError] = useState(false);

    const handleClose = () => {
        close();
    };

    //Ref - https://www.geeksforgeeks.org/interval-tree/
    class Interval {
        constructor() {
            this.low = 0;
            this.high = 0;
        }
    }

    class ITNode {
        // 'i' could also be a normal variable
        constructor() {
            this.max = 0;
            this.left = null;
            this.right = null;
            this.i = null;
        }
    }

    // A utility function to create a new node
    function newNodeDouble(l, h) {
        var temp = new Interval();
        temp.low = l;
        temp.high = h;
        return temp;
    }

    // A utility function to create a new node
    function newNodeSingle(i) {
        var temp = new ITNode();
        temp.i = i;
        temp.max = i.high;
        temp.left = temp.right = null;
        return temp;
    }

    // A utility function to insert a new
    // Interval Search Tree Node. This is
    // similar to BST Insert. Here the
    // low value of interval is used to
    // maintain BST property
    function insert(root, i) {

        // Base case: Tree is empty,
        // new node becomes root
        if (root == null)
            return newNodeSingle(i);

        // Get low value of interval at root
        var l = root.i.low;

        // If root's low value is smaller,
        // then new interval goes to left subtree
        if (i.low < l)
            root.left = insert(root.left, i);

        // Else, new node goes to right subtree.
        else
            root.right = insert(root.right, i);

        // Update the max value of this
        // ancestor if needed
        if (root.max < i.high)
            root.max = i.high;
        return root;
    }

    // A utility function to check if given
    // two intervals overlap
    function doOVerlap(i1, i2) {
        if (i1.low < i2.high && i2.low < i1.high)
            return true;
        return false;
    }

    // The main function that searches a given
    // interval i in a given Interval Tree.
    function overlapSearch(root, i) {

        // Base Case, tree is empty
        if (root == null)
            return null;

        // If given interval overlaps with root
        if (doOVerlap(root.i, i))
            return root.i;

        // If left child of root is present
        // and max of left child is greater
        // than or equal to given interval,
        // then i may overlap with an interval
        // is left subtree
        if (root.left != null &&
            root.left.max >= i.low)
            return overlapSearch(root.left, i);

        // Else interval can only
        // overlap with right subtree
        return overlapSearch(root.right, i);
    }

    // This function prints all conflicting
    // appointments in a given array of apointments.
    function printConflicting(appt, n) {

        // Create an empty Interval Search
        // Tree, add first appointment
        var root = null;
        root = insert(root, appt[0]);

        // Process rest of the intervals
        for (var i = 1; i < n; i++) {

            // If current appointment conflicts
            // with any of the existing intervals,
            // print it
            var res = overlapSearch(root, appt[i]);

            if (res != null) {
                appt[i].conflicted = true;
                res.conflicted = true;
            }
            // Insert this appointment
            root = insert(root, appt[i]);
        }
    }

    const validateConditions = () => {
        const intervals = [];
        formatList.forEach(c => {
            if (c.operator === 'Greater Than') {
                intervals.push(newNodeDouble(c.field1, Number.MAX_SAFE_INTEGER));
            }
            else if (c.operator === 'Less Than') {
                intervals.push(newNodeDouble(0, c.field1));
            }
            else if (c.operator === 'Between') {
                intervals.push(newNodeDouble(c.field1, c.field2));
            }
            else if (c.operator === 'Equals') {
                intervals.push(newNodeDouble(c.field1, c.field1));
            }
        });
        printConflicting(intervals, intervals.length);
        return intervals;
    };

    const handleSubmit = async (e) => {
        let val = false;

        if (formatType === 'numeric') {
            let gaps = validateConditions();
            let formatlist = formatList;
            let conflict = false;
            gaps.forEach((c, i) => {
                formatlist[i].conflicted = c.conflicted ? true : false;
                if (c.conflicted)
                    conflict = true;
            });
            if (conflict) {
                setFormatList([...formatlist]);
                val = false;
            }
        }
        let obj = formatObj;
        obj[formatKey] = JSON.parse(JSON.stringify(formatList));

        setFormatObj(obj);
        val = true;

        if (val) {
            setShowError(false);
            close();
            if (updateUserView) {
                await updateUserView(obj);
            }
        } else {
            setShowError(true);
        }
    };

    const handleAdd = (e, i) => {
        let formatlist = formatList && formatList.length > 0 ? formatList : [];
        formatlist.push({ 'operator': '', 'condition': '' });
        setFormatList([...formatlist]);
    };

    const handleDelete= (e, i) => {
        let formatlist = formatList && formatList.length > 0 ? formatList : [];
        formatlist.splice(i, 1);
        setFormatList([...formatlist]);
    };

    const updateFormat = (data, i, key) => {
        let formatlist = formatList && formatList.length > 0 ? formatList : [];
        if (formatlist[i]) {
            formatlist[i][key] = data;
        }
        else {
            let obj = {};
            obj[key] = data;
            formatlist.push(obj);
        }
        setFormatList([...formatlist]);
    };

    const handleChangeTime = (name, i, field) => {
        return (value, event) => {
            if (value) {
                updateFormat(value, i, field);
            }
        };
    };

    const getDValue = (key) =>{
        if (typeof(key) === 'string') {
            return new Date(key);
        }
        else {
            return key;
        }
    };

    const handleChange1 = (e,i) =>{
        updateFormat(formatType === 'numeric' ? Number(e.target.value) : e.target.value, i, 'field1');
    };

    const handleChange2 = (e,i) =>{
        updateFormat(formatType === 'numeric' ? Number(e.target.value) : e.target.value, i, 'field2');
    };

    return (
        <BobModal
            onCancel={handleClose}
            onClose={handleClose}
            onConfirm={handleSubmit}
            rootClass={'conditional-modal'}
            open={open}
            cancelText={'Cancel'}
            applyHidden={false}
            isRemoveFooter={false}
            title={'Add Conditional Formatting'}
        >
            <div>
                <div>
                    <div className={classes.formRow} style={{height: 30}}>  
                        <div className={classes.Column_1}>
                            Format cells that are
                        </div>
                        <div className={classes.Column_2}>
                            Value
                        </div>
                        <div className={classes.Column_3}>
                            And
                        </div>
                        <div className={classes.Column_4}>
                            With
                        </div>
                        <div className={classes.Column_5} />
                    </div>
                    <React.Fragment>
                        {formatList && formatList.length > 0 ?
                            <React.Fragment>
                                {
                                    formatList.map((item, i) => (
                                        <div className={`${classes.formRow} ${item.conflicted ? 'error-row' : ''}`}>  
                                            <div  className={`${classes.Column_1} col-1`}>
                                                <div className={classes.ActionButtonContainer}>
                                                    <div className={classes.ActionButtonContainer}>
                                                        <ConditionalFormatDropdown
                                                            type="operator"
                                                            fieldType={formatType}
                                                            index = {i}
                                                            val = {item.operator ? item.operator : ''}
                                                            updateFormat={updateFormat}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`${classes.Column_2} col-2`} style={formatType === 'date' ? {paddingLeft: 10, paddingRight: 10}: {}}>
                                                {
                                                    formatType === 'numeric' ?
                                                        <TextField
                                                            type="number" 
                                                            step=".01" 
                                                            onChange={(e) => handleChange1(e,i)}
                                                            id="outlined-basic"
                                                            value={item.field1} 
                                                            variant="outlined"
                                                        />
                                                        :
                                                        <React.Fragment>
                                                            {
                                                                formatType === 'boolean' ?
                                                                    <div className={classes.ActionButtonContainer}>
                                                                        <div className={classes.ActionButtonContainer}>
                                                                            <ConditionalFormatDropdown
                                                                                type="boolean"
                                                                                fieldType={formatType}
                                                                                index = {i}
                                                                                val = {item.field1 ? item.field1 : ''}
                                                                                updateFormat={updateFormat}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <React.Fragment>
                                                                        {formatType === 'date' ?
                                                                            <DateField
                                                                                dateFormat={'MM/dd/yyyy h:mm aa'}
                                                                                isClearable={true}
                                                                                label=""
                                                                                margin="dense"
                                                                                name={formatKey}
                                                                                onChange={handleChangeTime(formatKey, i, 'field1')}
                                                                                showTimeSelect={true}
                                                                                timeFormat={'h:mm a'}
                                                                                timeIntervals={15}
                                                                                value={getDValue(item.field1)}
                                                                                width={'300px'}
                                                                            />
                                                                            :
                                                                            <TextField
                                                                                type="text"  onChange={(e) => handleChange1(e, i)}
                                                                                id="outlined-basic"
                                                                                value={item.field1} 
                                                                                variant="outlined"
                                                                            />}
                                                                    </React.Fragment>
                                                            }
                                                        </React.Fragment>
                                                }
                                            </div>
                                            <div className={`${classes.Column_3} col-3`} style={formatType === 'date'?{paddingLeft: 10,paddingRight: 10}:{}}>
                                                {
                                                    item.operator === 'Between'?
                                                        <React.Fragment>
                                                            {
                                                                formatType === 'date' ?
                                                                    <DateField
                                                                        dateFormat={'MM/dd/yyyy h:mm aa'}
                                                                        isClearable={true}
                                                                        label=""
                                                                        margin="dense"
                                                                        name={formatKey}
                                                                        onChange={handleChangeTime(formatKey, i, 'field2')}
                                                                        showTimeSelect={true}
                                                                        timeFormat={'h:mm a'}
                                                                        timeIntervals={15}
                                                                        value={getDValue(item.field2)}
                                                                    />:
                                                                    <TextField
                                                                        type="number" step=".01" id="outlined-basic"
                                                                        onChange={(e) =>handleChange2(e,i)}
                                                                        value={item.field2} variant="outlined"
                                                                    />}
                                                        </React.Fragment>:''}
                                            </div>
                                            <div className={`${classes.Column_4} col-4`}>
                                                <div className={classes.ActionButtonContainer}>
                                                    <ConditionalFormatDropdown
                                                        type="condition"
                                                        val = {item.condition?item.condition:''}
                                                        index = {i}
                                                        updateFormat={updateFormat}
        
                                                    />
                                                </div>
                                            </div>
                                            <div className={`${classes.Column_5} col-5`}>
                                                <div className={classes.ActionButtonContainer}>
                                                    {formatList.length - 1 === i ?
                                                        <button  className={`circle-white`} onClick={(e) => handleAdd(e,i)}>
                                                            <i className={`fa fa-plus`} aria-hidden="true" />
                                                        </button>
                                                        :   <button  className={`circle-white`} onClick={(e) => handleDelete(e,i)}>
                                                            <i className={`fas fa-trash-alt`} aria-hidden="true" />
                                                        </button>}
                                                </div>
                                            </div>
                                        </div>
                                    ))} 
                            </React.Fragment>
                            :
                            <div className={classes.formRow}>  
                                <div  className={`${classes.Column_1} col-1`}>
                                    <div className={classes.ActionButtonContainer}>
                                        <div className={classes.ActionButtonContainer}>
                                            <ConditionalFormatDropdown
                                                type="operator"
                                                fieldType={formatType}
                                                index = {0}
                                                val = {''}
                                                updateFormat={updateFormat}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.Column_2}>
                                    {
                                        formatType === 'numeric' ?
                                            <TextField
                                                type="number" step=".01" onChange={(e) => handleChange1(e,0)}
                                                id="outlined-basic"
                                                variant="outlined"
                                            />:
                                            <TextField
                                                type="text"  onChange={(e) => handleChange1(e,0)}
                                                id="outlined-basic"
                                                variant="outlined"
                                            />
                                    }
                                </div>
                                <div className={classes.Column_3}>
                                    <TextField id="outlined-basic"  step=".01" variant="outlined" />
                                </div>
                                <div className={`${classes.Column_4} col-4`}>
                                    <div className={classes.ActionButtonContainer}>
                                        <ConditionalFormatDropdown
                                            type="condition"
                                            val = {''}
                                            index = {0}
                                            updateFormat={updateFormat}
                                        />
                                    </div>
                                </div>
                                <div className={`${classes.Column_5} col-5`}>
                                    <div className={classes.ActionButtonContainer}>
                                        <button  className={`circle-white`} onClick={(e) => handleAdd(e,0)}>
                                            <i className={`fa fa-plus`} aria-hidden="true" />
                                        </button>
                                         
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            showError?
                                <div style={{color: '#f00',fontSize: '1.3rem',padding: 20,height: '4.2rem !important'}} className={classes.formRow}>
                                    There is a conflict with the values you have entered, please check and update.
                                </div>
                                :
                                ''
                        }
                    </React.Fragment>
                    
                </div>

            </div>
        </BobModal>
    );
};

ConditionalFormatModal.propTypes = {

};

const mapStateToProps = state => {
    return {

    };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(ConditionalFormatModal);
